<template>
  <el-dialog
    append-to-body
    class="rtportal rt-vehicle-dialog big-dialog"
    :close-on-click-modal="false"
    title="产品列表"
    :visible.sync="dialogVisible"
  >
    <el-row>
      <!-- <el-col :span="4">搜索</el-col> -->
      <el-col :span="24">
        <el-input
          v-model="filterValue"
          @keyup.enter.native="handleSearch"
          placeholder="搜索产品名称、规格型号或产品线"
        >
          <el-button
            type="text"
            slot="append"
            icon="el-icon-search"
            style="margin-top:-12px;"
            @click="handleSearch"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      ref="vehicleTable"
      style="width: 100%"
      height="58%"
      :row-class-name="tabRowClassName"
      highlight-current-row
      :header-cell-style="{background:'#F8F9FA'}"
      v-bind:data="filteredData"
      border
      stripe
      @current-change="handleCurrentChange"
      @row-dblclick="handleConfirm"
      v-loading="loading"
    >
      <el-table-column width="55">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row == currentRow"></i>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        v-for="display in displayFields"
        v-bind:key="display.name"
        :prop="display.name"
        :label="display.label"
        :width="display.width"
      ></el-table-column>
      <template slot="empty">
        <img style="margin-top:50px;" src="../../../src/assets/imgs/home/no-order.png" alt />
        <p class="nodata-prompt">哎呀，暂时没有内容哦～</p>
      </template>
    </el-table>
    <div slot="footer" class='pagination-wrap'>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleIndexChange"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="totalRecordCount"
        style="margin-bottom:10px;text-align: center;"
      ></el-pagination>
      <span class="dialog-footer">
        <el-button @click="handleReset">移除值</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RtVehicleDialog",
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    displayFields: {
      type: Array,
      default: () => [
        { name: "Vehicle", label: "规格型号" },
        { name: "new_product_name", label: "产品名称" },
        { name: "new_product_line", label: "产品线" }
      ]
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      
      filterValue: "",
      
      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,
      
      filteredAllData: [], // 过滤后的所有数据
      filteredData: [], // 当前页显示的数据
      currentRow: null
    };
  },
  watch: {
    dataSource: {
      handler(newData) {
        this.updateFilteredData();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    tabRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "even-row";
      }
    },
    show() {
      this.dialogVisible = true;
      this.filterValue = "";
      this.pageIndex = 1;
      this.updateFilteredData();
    },
    handleSearch() {
      this.pageIndex = 1;
      this.updateFilteredData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageIndex = 1;
      this.updatePaginatedData();
    },
    handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.updatePaginatedData();
    },
    handleReset() {
      this.$emit("vehicle-selected", "");
      this.dialogVisible = false;
    },
    handleConfirm() {
      var selectedRow = this.$refs.vehicleTable.store.states.currentRow;
      if (!selectedRow) {
        this.$message.error("请选择一条记录");
        return;
      }

      // 返回选中的规格型号
      this.$emit("vehicle-selected", selectedRow.Vehicle);
      this.dialogVisible = false;
    },
    // 更新过滤后的数据
    updateFilteredData() {
      if (!this.dataSource || this.dataSource.length === 0) {
        this.filteredAllData = [];
        this.totalRecordCount = 0;
        this.filteredData = [];
        return;
      }

      // 如果没有搜索条件，显示所有数据
      if (!this.filterValue.trim()) {
        this.filteredAllData = [...this.dataSource];
      } else {
        // 根据搜索条件过滤数据（支持三列搜索）
        const searchValue = this.filterValue.toLowerCase().trim();
        this.filteredAllData = this.dataSource.filter(item => {
          const vehicle = (item.Vehicle || "").toLowerCase();
          const productName = (item.new_product_name || "").toLowerCase();
          const productLine = (item.new_product_line || "").toLowerCase();
          
          return vehicle.includes(searchValue) || 
                 productName.includes(searchValue) || 
                 productLine.includes(searchValue);
        });
      }
      
      this.totalRecordCount = this.filteredAllData.length;
      this.updatePaginatedData();
    },
    // 更新分页数据
    updatePaginatedData() {
      const start = (this.pageIndex - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.filteredData = this.filteredAllData.slice(start, end);
      
      this.$nextTick(() => {
        if (this.$refs.vehicleTable) {
          this.$refs.vehicleTable.doLayout();
        }
      });
    }
  }
};
</script>

<style scoped>
.rt-vehicle-dialog .el-dialog {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 800px;
  margin: 0px !important;
}

.rt-vehicle-dialog .el-table {
  margin-top: 15px;
  padding-bottom: 100px;
  box-sizing: border-box;
}

.rt-vehicle-dialog .el-table__body-wrapper {
  height: calc(100% - 40px) !important;
}

.rt-vehicle-dialog .el-dialog__body {
  padding-bottom: 15px;
}

.big-dialog .el-row {
  padding: 15px 20px 0 15px;
  line-height: 2;
  color: #143e81 !important;
}

.el-icon-circle-check:before {
  display: none !important;
}

.el-input__validateIcon {
  display: none !important;
}

.nodata-prompt {
  color: #999;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// vehicle-dialog.vue?2da6dcbe